<template>
  <div class="Filters">
    <Btn
      v-for="(option, index) in options"
      :key="option.label"
      class="dark sm"
      :class="{ active: activeIndex === index }"
      @click="$emit('update:activeIndex', index)">
      {{ option.label }}
    </Btn>
  </div>
</template>

<script>
export default {
  props: {
    activeIndex: Number,
    options: Array,
  },
}
</script>

<style lang="scss">
.Filters {
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-bottom: 0.5rem;

  @include sm {
    flex-direction: row;
  }

  > .Btn {
    margin-bottom: 0.5rem;
    margin-right: 1rem;

    &.active {
      background: $black-bis;
      border-color: $black-bis;
    }
  }
}
</style>
